<!--大健康渠道商 老渠道商补充健康协议 -->
<template>
    <div class="wrapper">
        <div class="channelWrap flex flex-column">
            <div class="header flex f16 a-center pl16 pr16">
                <div class="fb f16">当前位置：</div>
                <div class="color909399">老渠道商补充健康协议</div>
            </div>

            <div class="flex a-center pl16 pr16 pb24">
                <div class="flex a-center tipsBox pr16">
                    <img style="margin-right: 8px" src="../../assets/images/info-circle.png" alt="" />
                    <span class="hw_ml5">
                        温馨提示：仅可添加大健康成立后房产员工转大健康员工对接渠道商，补充的健康协议（不可维护老渠道商信息，由房产维护）。
                    </span>
                </div>
            </div>

            <div class="content flex1 pl16 pr16">
                <el-form
                    class="private"
                    :model="PB"
                    :rules="rules"
                    label-width="160px"
                    label-suffix=":"
                    ref="form"
                    @submit.prevent="handleSave"
                >
                    <el-row class="">
                        <el-col :md="12" :lg="12">
                            <el-form-item label="渠道商电话" prop="phone" class="setform32">
                                <el-input
                                    v-model="PB.phone"
                                    placeholder="请输入渠道商电话"
                                    maxlength="11"
                                    @blur="handlePhone"
                                />
                            </el-form-item>
                            <el-form-item label="协议名称" prop="confid" class="setform32">
                                <el-select v-model="PB.confid" style="width: 100%" disabled>
                                    <el-option
                                        :class="e.viewState === 0 ? 'treatyselectccc' : ''"
                                        v-for="e in treatyList"
                                        :key="e.id"
                                        :label="e.name"
                                        :value="e.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="协议开始时间" prop="starttime" class="setform32">
                                <el-date-picker
                                    type="date"
                                    placeholder="选择日期"
                                    v-model="PB.starttime"
                                    style="width: 100%"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    @change="chooseStime"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="协议结束时间" prop="endtime" class="setform32">
                                <el-date-picker
                                    type="date"
                                    placeholder="选择日期"
                                    v-model="PB.endtime"
                                    style="width: 100%"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="签约员工" prop="empid" class="setform32">
                                <p>{{ this.empOptions[0].label }}</p>
                                <!-- <template>
                                    <el-select
                                        v-model="PB.empid"
                                        filterable
                                        remote
                                        reserve-keyword
                                        placeholder="请输入"
                                        disabled
                                        class="width3"
                                    >
                                        <el-option
                                            v-for="item in empOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </template> -->
                            </el-form-item>

                            <el-form-item label=" 开户支行名" prop="bankname" class="setform32">
                                <el-input v-model="PB.bankname" placeholder="请输入开户支行名" />
                            </el-form-item>
                            <el-form-item label=" 账户名称" prop="accountname" class="setform32">
                                <el-input v-model="PB.accountname" placeholder="请输入账户名称" />
                            </el-form-item>
                            <el-form-item label=" 账户号码" prop="banknum" class="setform32">
                                <el-input v-model="PB.banknum" placeholder="请输入账户号码" maxlength="30" />
                            </el-form-item>
                            <el-form-item label=" 签署方式" prop="signtype" class="setform32">
                                <el-radio-group v-model="PB.signtype">
                                    <el-radio :label="0">线下财务申领签约</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="附件" prop="imgPath" class="imgform">
                                <div v-if="pdfList" class="flex">
                                    <div
                                        @click="handfile(item)"
                                        class="imgItem"
                                        v-for="(item, index) in pdfList"
                                        :key="index"
                                    >
                                        <img class="inlineblock img c-pointer" src="../../assets/images/pdfview.png" />
                                        <i class="el-icon-delete del" @click.stop="delBackFile(index)"></i>
                                    </div>
                                </div>
                                <viewer :images="fileList">
                                    <div class="flex">
                                        <div class="imgItem" v-for="(item, index) in fileList" :key="index">
                                            <img class="inlineblock img c-pointer" :src="item.url" />
                                            <i class="el-icon-delete del" @click.stop="delBackPic(index)"></i>
                                        </div>
                                    </div>
                                </viewer>
                                <el-upload
                                    :data="needzip"
                                    v-show="fileList.length + pdfList.length <= 4"
                                    class="avatar-uploader"
                                    :action="picUrl"
                                    :show-file-list="false"
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    :on-success="handleBackImgSuccess"
                                    :before-upload="handleBeforeUpload"
                                    :on-progress="handleProgress"
                                >
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>

                            <div class="tip" style="margin-left: 160px; color: #909399; font-size: 12px">
                                附件类型：图片和pdf,大小小于5M，最多只能上传5个附件
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="foot-bar">
                <el-button @click="closeCurrentWindow">取消</el-button>
                <el-button @click="handleSave" type="primary">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { base64encode, utf16to8, utf8to16, base64decode } from '../../utils/base64';
    export default {
        data() {
            return {
                urlQuery: '',
                PB: {
                    phone: '', //渠道商电话
                    channelid: '', //渠道商id
                    empid: '', //签约员工
                    confid: '', //协议id
                    starttime: '', //协议开始时间
                    endtime: '', //协议结束时间
                    signtype: 0, //签署方式
                    bankname: '', //开户支行名
                    accountname: '', //账户名称
                    banknum: '', //账户号码
                    imgPath: '', //附件
                },
                fileList: [], //附件
                pdfList: [], //pdf附件
                picUrl: this.$baseURL + '/api/common/fileSingleUpLoad',
                needzip: {
                    isZip: 1,
                },
                showPicUrl: '',
                rules: {
                    phone: {
                        required: true,
                        message: '请输入渠道商电话',
                        trigger: 'blur',
                    },
                    type: {
                        required: true,
                        message: '请选择类型',
                        trigger: 'blur',
                    },
                    empid: {
                        required: true,
                        message: '请输入对接员工',
                        trigger: 'blur',
                    },
                    confid: {
                        required: true,
                        message: '请选择协议名称',
                        trigger: 'blur',
                    },
                    starttime: {
                        required: true,
                        message: '请选择开始日期',
                        trigger: 'blur',
                    },
                    endtime: {
                        required: true,
                        message: '请选择结束日期',
                        trigger: 'blur',
                    },
                    imgPath: {
                        required: true,
                        message: '请上传附件',
                        trigger: ['change', 'blur'],
                    },
                },
                treatyList: [], //协议合集
            };
        },
        watch: {
            'PB.endtime'(val) {
                if (val) {
                    // 存在值 就清空提示
                    this.$refs.form.clearValidate('endtime');
                }
            },
            fileList(val) {
                if (val) {
                    this.$refs.form.clearValidate('imgPath');
                }
            },
        },
        created() {
            this.urlQuery = this.getUrlQuery();
            console.log('1111111', this.urlQuery);
            this.getConfigByType();
            console.log('this.userInfo', this.userInfo);
            this.empOptions = [
                {
                    name: this.userInfo.name,
                    phone: this.userInfo.phone,
                    usercode: this.userInfo.usercode,
                    value: this.userInfo.usercode,
                    label: this.userInfo.name + '--' + this.userInfo.phone,
                },
            ];
            this.PB.empid = this.userInfo.employeeId;
        },
        methods: {
            // 获取url参数
            getUrlQuery() {
                const env = process.env.NODE_ENV;

                let url;

                if (env === 'development') {
                    url =
                        'http://192.168.110.150:8020/center/#/customer/djkAgreement?c3lzQ29kZT1DUk0mZWRpdFBob25lRmxhZz0xJnNob3dQaG9uZUZsYWc9MSZjaGFuQ29kZT1DSC1BWU02Mg=%3D';
                } else {
                    url = window.location.href;
                }

                let urlStrDe = url.split('?')[1];
                let urlStr = base64decode(urlStrDe);

                // 创建空对象存储参数
                let obj = {};
                // 再通过 & 将每一个参数单独分割出来
                let paramsArr = urlStr.split('&');
                for (let i = 0, len = paramsArr.length; i < len; i++) {
                    // 再通过 = 将每一个参数分割为 key:value 的形式
                    let arr = paramsArr[i].split('=');
                    obj[arr[0]] = arr[1];
                }
                return obj;
            },
            // 获取协议合集
            async getConfigByType() {
                const res = await this.$axios({
                    url: '/api/configuration/queryConfigByType',
                    method: 'post',
                    data: {
                        type: 1, //字典类型 1协议 2行业
                        pid: 0, //父级id
                    },
                });
                if (res.code === 2000) {
                    this.treatyList = res.data.configurationList;

                    this.PB.confid = this.treatyList.find(item => item.value === '289').id;
                }

                console.log('获取协议合集', res);
            },
            async handlePhone() {
                console.log(this.PB.phone);

                if (this.PB.phone) {
                    this.PB.phone = this.PB.phone.replace(/\D/g, '');
                }

                // 中国电话号码验证
                const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
                if (!reg.test(this.PB.phone)) {
                    this.$message.error('请输入正确的手机号码');
                    return false;
                }

                const res = await await this.$axios({
                    url: '/api/channel/queryHealthChannel',
                    method: 'post',
                    data: {
                        phone: this.PB.phone,
                    },
                });

                console.log(res);

                if (res.code === 2000) {
                    this.PB.channelid = res.data.channel.id || '';
                } else {
                    this.$alert('不允许添加健康协议，可能原因：渠道商不存在或不满足添加健康协议条件', {
                        confirmButtonText: '确定',
                    });
                }
            },
            chooseStime(data) {
                if (!data) {
                    this.PB.endtime = '';
                    return;
                }
                this.PB.endtime = this.getDateTime(data, 'date', 2);
            },
            //  两年后前一天
            getDateTime(date = new Date(), type = 'dateTime', afterNum) {
                if (date === '') return '';
                else {
                    date = new Date(date);
                }
                date.setFullYear(date.getFullYear() + afterNum); //几年后
                let dateparse = Date.parse(date);
                let newdateparse = dateparse - 3600 * 24 * 1000; //减一天
                date = new Date(newdateparse);
                var seperator1 = '-',
                    seperator2 = ':',
                    year = date.getFullYear(),
                    month = date.getMonth() + 1,
                    strDate = date.getDate(),
                    hour = date.getHours(),
                    minute = date.getMinutes(),
                    second = date.getSeconds();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate;
                }
                if (hour >= 0 && hour <= 9) {
                    hour = '0' + hour;
                }
                if (minute >= 0 && minute <= 9) {
                    minute = '0' + minute;
                }
                if (second >= 0 && second <= 9) {
                    second = '0' + second;
                }
                var theDate;
                if (type === 'year') {
                    theDate = year;
                } else if (type === 'dateTime') {
                    theDate =
                        year +
                        seperator1 +
                        month +
                        seperator1 +
                        strDate +
                        ' ' +
                        hour +
                        seperator2 +
                        minute +
                        seperator2 +
                        second;
                } else if (type === 'date') {
                    theDate = year + seperator1 + month + seperator1 + strDate;
                } else if (type === 'month') {
                    theDate = year + seperator1 + month;
                } else if (type === 'monthDate') {
                    theDate = year + seperator1 + month + seperator1 + strDate + ' ' + hour + seperator2 + minute;
                }
                console.log('theDate' + theDate);
                return theDate;
            },

            handPdf(item) {
                window.open(item.url);
            },
            handleProgress(e, file) {
                this.posting = true;
            },

            handleBeforeUpload(file) {
                var img = file.name.substring(file.name.lastIndexOf('.') + 1);
                const suffix = img === 'jpg';
                const suffix2 = img === 'png';
                const suffix3 = img === 'jpeg';
                const suffix4 = img === 'pdf';
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!suffix && !suffix2 && !suffix3 && !suffix4) {
                    this.$message.error('只能上传图片或pdf附件！');
                    return false;
                }
                if (!isLt5M) {
                    this.$message.error('上传文件大小不能超过 5MB!');
                    return false;
                }
                return suffix || suffix2 || suffix3 || suffix4;
            },
            // 上传文件成功
            handleBackImgSuccess(res, file) {
                console.log(res);
                console.log(file);
                this.posting = false;

                const suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                if (suffix == 'pdf') {
                    const index = this.pdfList.indexOf(file);
                    if (res.code === 2000) {
                        const { oldName, filePath } = res.data.files;
                        file.url = this.$baseURL + '/' + filePath;
                        file.path = filePath;
                        this.pdfList.push({
                            name: oldName,
                            url: this.$baseURL + '/' + filePath,
                            path: filePath,
                        });
                        console.log(this.pdfList);
                        let _imgPath = [];
                        this.pdfList.forEach(ele => {
                            _imgPath.push(ele.path);
                        });
                        this.PB.imgPath = _imgPath;
                    } else {
                        this.pdfList.splice(index, 1);
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        });
                    }
                } else {
                    const index = this.fileList.indexOf(file);
                    if (res.code === 2000) {
                        const { oldName, filePath } = res.data.files;
                        file.url = this.$baseURL + '/' + filePath;
                        file.path = filePath;
                        this.fileList.push({
                            name: oldName,
                            url: this.$baseURL + '/' + filePath,
                            path: filePath,
                        });
                        console.log(this.fileList);
                        let _imgPath = [];
                        this.fileList.forEach(ele => {
                            _imgPath.push(ele.path);
                        });
                        this.PB.imgPath = _imgPath;
                    } else {
                        this.fileList.splice(index, 1);
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        });
                    }
                }
            },
            // 删除图片
            delBackPic(index) {
                this.fileList.splice(index, 1);
            },
            // 删除图片
            delBackFile(index) {
                this.pdfList.splice(index, 1);
            },
            handfile(item) {
                window.open(item.url);
            },

            closeCurrentWindow() {
                window.close();
            },
            async handleSave() {
                let _imgPath = [];
                this.fileList.forEach(ele => {
                    _imgPath.push(ele.path);
                });
                this.pdfList.forEach(ele => {
                    _imgPath.push(ele.path);
                });
                this.PB.imgPath = _imgPath;

                this.$refs['form'].validate(async valid => {
                    if (valid) {
                        //    结束时间必须大于开始时间
                        const start = new Date(this.PB.starttime).getTime();
                        const end = new Date(this.PB.endtime).getTime();
                        if (start > end) {
                            this.$message({
                                message: '结束时间必须大于开始时间',
                                type: 'error',
                            });
                            return;
                        }

                        const res = await await this.$axios({
                            url: '/api/channel/queryHealthChannel',
                            method: 'post',
                            data: {
                                phone: this.PB.phone,
                            },
                        });

                        if (res.code !== 2000) {
                            this.$alert('不允许添加健康协议，可能原因：渠道商不存在或不满足添加健康协议条件', {
                                confirmButtonText: '确定',
                            });
                            return;
                        }

                        this.$axios({
                            url: '/api/channel/saveChannelTreaty',
                            method: 'post',
                            data: {
                                // id: this.PB.id,
                                confid: this.PB.confid, //协议id
                                starttime: this.PB.starttime, //开始时间
                                endtime: this.PB.endtime, //结束时间
                                signempid: this.PB.empid, //签约员工id
                                channelid: this.PB.channelid, //渠道id
                                signtype: this.PB.signtype, //签约类型 1线上 0线下
                                bankname: this.PB.bankname, //开户支行名
                                accountname: this.PB.accountname, //账户名称
                                banknum: this.PB.banknum, //账户号码
                                path: _imgPath.join(),
                            },
                        }).then(res => {
                            if (res.code === 2000) {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success',
                                });
                                setTimeout(() => {
                                    this.closeCurrentWindow();
                                }, 1000);
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                });
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .wrapper {
        height: 100%;
        padding: 80px;
        background: #f9f9f9;
    }
    @media (max-width: 1920px) {
        .wrapper {
            padding: 80px;
        }
    }
    // 小于1600时
    @media (max-width: 1600px) {
        .wrapper {
            padding: 40px;
        }
    }
    // 公用
    .pb24 {
        padding-bottom: 24px;
    }
    .pl16 {
        padding-left: 16px;
    }
    .pr16 {
        padding-right: 16px;
    }
    .flex-column {
        flex-direction: column;
    }
    .flex1 {
        flex: 1;
    }
    .a-center {
        align-items: center;
    }
    .flex {
        display: flex;
    }
    .fb {
        font-weight: 600;
    }
    .f16 {
        font-size: 16px;
    }

    .channelWrap {
        background: #fff;
        height: 100%;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
        .header {
            height: 62px;
        }
        .tipsBox {
            height: 40px;
            background: rgba(40, 120, 255, 0.1);
            color: #2878ff;
            border-radius: 2px;
            padding-left: 12px;
            width: 100%;
            line-height: 16px;
        }
        .foot-bar {
            display: flex;
            justify-content: center;
            align-items: center;
            // position: absolute;
            // bottom: 0;
            // left: 0;
            // right: 0;
            z-index: 9;
            height: 56px;
            // padding-left: 16px;
            // padding-right: 16px;
            background-color: white;
            box-shadow: 0px -2px 4px 0px rgba(200, 201, 204, 0.35);
        }
        .content {
            overflow: auto;
            .setform32 /deep/ .el-form-item__content {
                height: 32px;
            }

            .imgform /deep/ .el-form-item__label {
                line-height: normal;
            }
            .imgItem {
                width: 80px;
                height: 80px;
                margin-right: 12px;
                position: relative;
            }
            .imgItem .img {
                width: 80px;
                height: 80px;
                border-radius: 6px;
                border-top-right-radius: 10px;
            }

            .imgItem .del {
                position: absolute;
                width: 16px;
                height: 16px;
                right: 0px;
                color: #ccc;
                top: 2px;
                cursor: pointer;
            }
            .imgItem .del:hover {
                color: red;
            }
            /deep/ .el-icon-arrow-down {
                transition: transform 0.2s ease-in-out;
                transform: rotate(90deg);
            }
            // 上传图片
            .avatar-uploader /deep/ .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .avatar-uploader /deep/ .el-upload:hover {
                border-color: #409eff;
            }
            .avatar-uploader-icon {
                font-size: 24px;
                color: #8c939d;
                width: 80px;
                height: 80px;
                line-height: 80px;
                text-align: center;
            }
            .avatar {
                width: 80px;
                height: 80px;
                display: block;
            }
        }
    }
</style>
